import { Helper } from './types';

/**
 * Helper function to generate the class name string for a JSX element.
 *
 * @param fixed The fixed class name part.
 * @param parameters The optional class name parameters.
 *
 * @returns The class name string.
 */
const helper: Helper = (fixed, parameters) => {
  return Object.entries(parameters).reduce(
    (className, [parameter, active]) =>
      className +
      (active
        ? (className ? ' ' : '') +
          parameter.replace(/([A-Z])/g, '-$1').toLowerCase()
        : ''),
    fixed
  );
};

export default helper;
